var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCompanyFundamentals = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 12.639q0-1.17.46-2.077.475-.908 1.27-1.395a3.4 3.4 0 0 1 1.798-.488q.865 0 1.506.349.656.348 1.046.878V8.805l1.967-.35v8.074H6.08V15.4q-.376.544-1.046.907-.655.349-1.52.349-.976 0-1.785-.502Q.934 15.65.46 14.744 0 13.824 0 12.64m6.08.028q0-.71-.279-1.213a1.9 1.9 0 0 0-.753-.781 2 2 0 0 0-1.018-.279q-.543 0-1.004.265a2.03 2.03 0 0 0-.753.78q-.279.502-.279 1.2t.28 1.227q.291.516.752.795.474.279 1.004.279.544 0 1.018-.265.474-.28.753-.781.28-.516.28-1.227M18 6.797l-3.57 9.732h-2.37L8.49 6.797h2.091l2.678 7.738 2.663-7.738zM8.604 1.978c.005 4.47-1.717 6.582-4.166 5.32.716-1.085 1.229-1.616 2.284-2.468-1.026.694-1.577 1.152-2.468 2.238-2.179-3.716 3.36-4.179 4.35-5.09M.448 4.888C.365 7.6 1.372 8.912 2.88 8.189c-.415-.67-.716-1.002-1.342-1.537.61.439.937.727 1.458 1.402C4.385 5.838 1.03 5.458.448 4.888"
  })));
};
export default SvgCompanyFundamentals;